import { jsxs as p, jsx as t } from "react/jsx-runtime";
import I from "classnames";
import { useRef as v, useState as L, useEffect as j } from "react";
import o from "./index.es751.js";
import { EmptyStateIllustration as k } from "./index.es480.js";
import { Heading as E } from "./index.es507.js";
import { BodyText as S } from "./index.es505.js";
import { Button as W } from "./index.es15.js";
const J = ({
  title: w,
  message: B,
  testId: r,
  buttonText: i,
  buttonVariant: y = "primary-brand",
  secondaryButtonText: s,
  secondaryButtonVariant: N = "secondary-blue",
  illustration: c,
  onButtonClick: d,
  onSecondaryButtonClick: l,
  isFilteredResults: a = !1
}) => {
  const m = v(null), f = v(null), [b, h] = L(!1);
  j(() => {
    (() => {
      const n = m.current, e = f.current;
      if (!n && !e) return;
      const R = (n == null ? void 0 : n.offsetWidth) || 0, C = (e == null ? void 0 : e.offsetWidth) || 0;
      R > 232 || C > 232 ? h(!0) : h(!1);
    })();
  }, [i, s]);
  const x = !!(i && d), u = !!(s && l);
  return /* @__PURE__ */ p("div", { className: o.noRowsContainer, "data-testid": r, children: [
    /* @__PURE__ */ t("div", { className: o.noRowsIllustration, children: c || /* @__PURE__ */ t(k, { size: 400 }) }),
    /* @__PURE__ */ t(E, { variant: "h4", element: "span", children: w }),
    /* @__PURE__ */ t(
      "div",
      {
        role: a ? "alert" : void 0,
        "aria-live": a ? "assertive" : void 0,
        tabIndex: a ? -1 : void 0,
        children: /* @__PURE__ */ t(S, { children: B })
      }
    ),
    /* @__PURE__ */ p(
      "div",
      {
        className: I(o.buttonsContainer, {
          [o.twoLines]: b,
          [o.oneButton]: !u
        }),
        children: [
          u && /* @__PURE__ */ t(
            W,
            {
              variant: N,
              onClick: l,
              testId: `${r}-secondary-button`,
              fullWidth: !0,
              ref: f,
              children: s
            }
          ),
          x && /* @__PURE__ */ t(
            W,
            {
              variant: y,
              onClick: d,
              testId: `${r}-button`,
              fullWidth: !0,
              ref: m,
              children: i
            }
          )
        ]
      }
    )
  ] });
};
export {
  J as NoRowsComponent
};
//# sourceMappingURL=index.es601.js.map
